import React from 'react';
import { withInjectedProps } from 'Components/Core/InjectedPropsContext';
import { useSelector } from 'react-redux';
import {
  WorksheetGridFieldSection,
  IWithWorksheetInjectedProps,
  WorksheetRecordGrid,
} from 'Components/Worksheets/Core';
import { Field, Checkbox } from 'Components/Core';
import deepEquals from 'Lib/Object/deepEquals';
import { valueOrDefault } from 'Lib/Any';
import { pipe } from 'Lib/Hooks/Selectors';
import { prefixRecordFieldSetNames } from 'Components/Worksheets/Core/WorksheetRecordGrid/helpers';
import { getGridFieldSet as getMoistureContentGridFieldSet } from 'Components/Worksheets/MoistureContentWorksheet/Aashto/gridFieldSets';
import { createDryMassEntryOptionSelector } from 'Components/Worksheets/MoistureContentWorksheet';

let AtterbergLimitPlasticLimitTrialSection: React.FC<IWithWorksheetInjectedProps> = ({ createWorksheetSelector }) => {
  const dryMassEntryOption = useSelector(createDryMassEntryOptionSelector(createWorksheetSelector!));

  const trialRecordProps = useSelector(
    pipe(createWorksheetSelector!('Trials'), valueOrDefault([] as Array<any>), (trials) =>
      trials.map((t) => ({
        dim: t.ExcludedTrial,
      }))
    ),
    deepEquals
  );

  return (
    <WorksheetGridFieldSection name="Trials">
      <WorksheetRecordGrid
        name={'Trials'}
        orientation={'horizontal'}
        recordProps={{
          width: 130,
          dim: (i) => trialRecordProps[i]?.dim,
          enforceAtLeastOneRecord: true,
          removeConfirm: {
            confirm: true,
            confirmTitle: 'Trial Deletion',
            confirmText: 'Are you sure you want to delete the selected trial?',
            confirmButtonText: 'Delete Trial',
          },
        }}
        fieldSet={[
          ...prefixRecordFieldSetNames('MoistureDetermination', getMoistureContentGridFieldSet(dryMassEntryOption)),
          {
            name: 'ExcludedTrial',
            component: <Field input={<Checkbox />} />,
            label: 'Exclude Trial', // Remove when labels migrated to config
          },
        ]}
      />
    </WorksheetGridFieldSection>
  );
};

AtterbergLimitPlasticLimitTrialSection = withInjectedProps(AtterbergLimitPlasticLimitTrialSection);

export { AtterbergLimitPlasticLimitTrialSection as AtterbergLimitTrialSection };
export default AtterbergLimitPlasticLimitTrialSection;
